/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import PrintHelperCss from "./PrintHelper.css";
import { discovery } from "dc-core";
import { trackPrintHelperIframeLoaded, trackPrintHelperIframeNotLoaded } from "analytics/events";

class PrintHelper extends Component {
  constructor(props) {
    super(props);
    this.iframeHandle = null;
    this.onIframeLoaded = this.onIframeLoaded.bind(this);
  }

  onIframeLoaded() {
    try {
      if (!this.iframeHandle.contentDocument) throw new Error("PrintHelper iframe is not loaded");
      trackPrintHelperIframeLoaded();
      this.props.onIframeLoaded(this.iframeHandle);
    } catch (e) {
      trackPrintHelperIframeNotLoaded();
    }
  }

  render() {
    if (discovery) {
      const previewPath = discovery.dropins.preview.public_path;
      const printHelperIframePath = `${previewPath}printHelper.html`;

      return this.props.shouldLoadIntermediateIframe ? (
        <iframe
          ref={handle => (this.iframeHandle = handle)}
          tabIndex={-1}
          onLoad={this.onIframeLoaded}
          src={printHelperIframePath}
          className={PrintHelperCss.printHelperContainerIframe}
        />
      ) : null;
    }

    return null;
  }
}

export { PrintHelper };
